/**
* @file 404
**/
<template>
  <div id="notFound">
    <div class="wrapper">
      <div class="img-wrapper">
        <img src="../../assets/img/404.png" alt="">
      </div>
      <p class="sorry">很抱歉，您访问的页面不在地球上...</p>
      <div class="timer">
        <i class="el-icon-loading"></i>
        <span class="time">{{`${time}秒`}}</span>
        <span class="text">后自动跳转到首页，如没有跳转请点击此链接</span>
      </div>
      <p class="goBack-wrapper" @click="goBackFn">返回首页</p>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: '',
    computed: {
      ...mapGetters({})
    },
    data () {
      return {
        // 倒计时起始时间
        time: 5,
        // 定时器
        timer: ''
      }
    },
    methods: {
      /**
       * 倒计时
       */
      countDownFn () {
        if (this.time < 1) {
          this.goBackFn()
        } else {
          this.timer = setTimeout(() => {
            this.time--;
            this.countDownFn()
          }, 1000)
        }
      },
      /**
       * 返回首页
       */
      goBackFn () {
        this.$router.replace('/')
      }
    },
    mounted () {
      this.countDownFn()
    },
    destroyed () {
      clearTimeout(this.timer)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  #notFound {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    .wrapper {
      width: 380px;
      height: 280px;
      .img-wrapper {
        font-size: 0;
        height: 95px;
        text-align: center;
        margin-bottom: 48px;
      }
      .sorry {
        width: 100%;
        text-align: center;
        font-size: 24px;
        color: #1f2f3d;
        margin-bottom: 17px;
      }
      .timer {
        width: 100%;
        font-size: 0;
        margin-bottom: 37px;
        .text {
          color: #99a9bf;
        }
        .time {
          color: #f67d12;
          padding-left: 7px;
        }
        i, span {
          font-size: 14px;
        }
      }
      .goBack-wrapper {
        width: 100%;
        height: 40px;
        text-align: center;
        background-color: #0193f3;
        color: #fff;
        font-size: 16px;
        border-radius: 4px;
        line-height: 40px;
        cursor: pointer;
      }
    }
  }
</style>
